<template>

	<div id="reyrock-landing">

		<core-hero contentKey="landing_hero">
			<div class="corp-hero__galleryreyrocklanding">
				<img :src="'reyrock/reyrock18.webp' | assetsImg" alt="">
				<img :src="'reyrock/reyrock17.webp' | assetsImg" alt="">
				<img :src="'reyrock/reyrock16.webp' | assetsImg" alt="">
				<img :src="'reyrock/reyrock19.webp' | assetsImg" alt="">
				<img :src="'reyrock/reyrock20.webp' | assetsImg" alt="">
				<img :src="'reyrock/reyrock21.webp' | assetsImg" alt="">
			</div>
		</core-hero>

		<div id="where-potential-becomes-opportunity">

			<div class="limit-width">

				<div class="reyrock-section-heading">

					<span class="reyrock-section-label">
						WHAT IS REYROCK?
					</span>

					<h2>
						{{ "landing_potential" | staticTitle }}
					</h2>

				</div>

				<div class="reyrock-section-content">

					<vue-marked>
						{{ "landing_potential" | staticContent }}
					</vue-marked>

				</div>

			</div>

		</div>

		<div id="three-expressions-of-opportunity">

			<div class="limit-width">

				<h2>
					{{ "landing_three-expressions" | staticTitle }}
				</h2>

				<vue-marked>
					{{ "landing_three-expressions" | staticContent }}
				</vue-marked>

			</div>

		</div>

		<divisions
			id="divisions"
			:items="[
				{
					key: 'properties_landing',
					classIcon: 'fa-solid fa-briefcase',
					href: { name: 'Properties' },
					img: 'properties_landing'
				},
				{
					key: 'ventures_landing',
					classIcon: 'fa-solid fa-rocket',
					href: { name: 'Ventures' },
					img: 'ventures_landing'
				},
				{
					key: 'talent_landing',
					classIcon: 'fa-solid fa-meteor',
					href: { name: 'Talent' },
					img: 'talent_landing'
				}
			]"
		/>

		<div id="what-makes-an-opportunity-a-reyrock-opportunity">

			<div class="limit-width">

				<h2>
					{{ "landing_reyrock-opportunity" | staticTitle }}
				</h2>

				<vue-marked class="reyrock-opportunity-content">
					{{ "landing_reyrock-opportunity" | staticContent }}
				</vue-marked>

			</div>

		</div>

		<div id="the-reyrock-development-model">

			<div class="limit-width">

				<h2>
					{{ "landing_reyrock-development" | staticTitle }}
				</h2>

				<vue-marked>
					{{ "landing_reyrock-development" | staticContent }}
				</vue-marked>

			</div>

		</div>

		<div id="reyrock-bridgerocks">

			<div class="limit-width">

				<h2>
					{{ "landing_reyrock-bridgerocks" | staticTitle }}
				</h2>

				<vue-marked>
					{{ "landing_reyrock-bridgerocks" | staticContent }}
				</vue-marked>

			</div>

		</div>

		<div id="value-is-often-discovered-before-it-is-visible">

			<div class="limit-width">

				<h2>
					{{ "landing_value-visible" | staticTitle }}
				</h2>

				<vue-marked>
					{{ "landing_value-visible" | staticContent }}
				</vue-marked>

			</div>

		</div>

		<div id="selected-opportunities">

			<div class="limit-width">

				<h2>
					{{ "landing_selected-opportunities" | staticTitle }}
				</h2>

				<div class="selected-opportunities__grid">

					<article class="selected-opportunity">

						<h3>
							{{ "landing_elements-collection" | staticTitle }}
						</h3>

						<vue-marked>
							{{ "landing_elements-collection" | staticContent }}
						</vue-marked>

						<router-link
							:to="{ name: 'Properties' }"
							class="selected-opportunity__button"
						>
							Explore Properties →
						</router-link>

					</article>

					<article class="selected-opportunity">

						<h3>
							{{ "landing_pneumaroca" | staticTitle }}
						</h3>

						<vue-marked>
							{{ "landing_pneumaroca" | staticContent }}
						</vue-marked>

						<router-link
							:to="{ name: 'PneumaRoca' }"
							class="selected-opportunity__button"
						>
							Discover PneumaRoca →
						</router-link>

					</article>

					<article class="selected-opportunity">

						<h3>
							{{ "landing_beynd" | staticTitle }}
						</h3>

						<vue-marked>
							{{ "landing_beynd" | staticContent }}
						</vue-marked>

						<router-link
							:to="{ name: 'Beynd' }"
							class="selected-opportunity__button"
						>
							Discover Beynd →
						</router-link>

					</article>

				</div>

			</div>

		</div>

		<div id="reyrock-final-cta">

			<div class="limit-width">

				<h2>
					{{ "landing_final-cta" | staticTitle }}
				</h2>

				<div class="reyrock-final-cta__right">

					<vue-marked>
						{{ "landing_final-cta" | staticContent }}
					</vue-marked>

					<div class="reyrock-final-cta__buttons">

						<a
							href="#"
							class="reyrock-final-cta__button reyrock-final-cta__button--primary"
						>
							Present an Opportunity
						</a>

						<router-link
							:to="{ name: 'Properties' }"
							class="reyrock-final-cta__button reyrock-final-cta__button--secondary"
						>
							Explore Reyrock Properties
						</router-link>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
/* eslint-disable */
import CoreHero from './Landing/CoreHero.vue';
import Divisions from './Landing/Divisions.vue';

export default {
	name: 'ReyrockLanding',

	components: {
		CoreHero,
		Divisions
	},

	mounted() {
		document.title =
			'Bridgerocks | ' +
			this.$options.filters.toTitleCase(
				this.$options.filters.i('reyrock studio')
			);

		if (
			window.mainUI &&
			typeof window.mainUI === 'function'
		) {
			setTimeout(window.mainUI, 150);
		}
	}
};
</script>

<style lang="scss">
#reyrock-landing {

	.corp-hero__galleryreyrocklanding {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		grid-template-rows: repeat(2, minmax(0, 1fr));
		gap: 8px;
		width: 100%;
		height: 100%;
		min-height: 520px;

		img {
			display: block;
			width: 100%;
			height: 100%;
			min-width: 0;
			min-height: 0;
			object-fit: cover;
			object-position: center;
		}
	}

	@media screen and (max-width: 1400px) {

		.corp-hero__galleryreyrocklanding {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			grid-template-rows: repeat(3, minmax(150px, 1fr));
			min-height: 560px;
		}
	}

	@media screen and (max-width: 1100px) {

		.corp-hero__galleryreyrocklanding {
			grid-template-columns: repeat(3, minmax(0, 1fr));
			grid-template-rows: repeat(2, 200px);
			min-height: 0;
			height: auto;
			margin-top: 28px;
		}
	}

	@media screen and (max-width: 768px) {

		.corp-hero__galleryreyrocklanding {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			grid-template-rows: repeat(3, 170px);
			gap: 6px;
		}
	}

	@media screen and (max-width: 480px) {

		.corp-hero__galleryreyrocklanding {
			grid-template-columns: 1fr;
			grid-template-rows: repeat(6, 190px);
		}
	}
}
</style>